module.exports = __webpack_public_path__ + "static/media/Motorola Moto E White.ae84694a.png";